import {
  ADD_REQUEST_FOR_SIGNET_STATUS,
  ADD_REQUEST_FOR_SIGNET_STATUS_START,
  ADD_REQUEST_FOR_SIGNET_STATUS_ERROR,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_START,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ERROR,
} from '../actions/types';

const initialState = {
  requestForSignetStatusList: [],
  requestForSignetStatus: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const addRequestForSignetStatusStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addRequestForSignetStatus = (state, action) => {
  return {
    ...state,
    requestForSignetStatus: action.payload,
    error: undefined,
  };
};

const addRequestForSignetStatusError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findRequestForSignetStatusBySignetIdStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const findRequestForSignetStatusBySignetId = (state, action) => {
  return {
    ...state,
    requestForSignetStatus: action.payload,
    error: undefined,
  };
};

const findRequestForSignetStatusBySignetIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_REQUEST_FOR_SIGNET_STATUS:
      return addRequestForSignetStatus(state, action);
    case ADD_REQUEST_FOR_SIGNET_STATUS_START:
      return addRequestForSignetStatusStart(state);
    case ADD_REQUEST_FOR_SIGNET_STATUS_ERROR:
      return addRequestForSignetStatusError(state, action);

    case GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET:
      return findRequestForSignetStatusBySignetId(state, action);
    case GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_START:
      return findRequestForSignetStatusBySignetIdStart(state);
    case GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ERROR:
      return findRequestForSignetStatusBySignetIdError(state, action);

    default:
      return state;
  }
}
